import { defaultRegionInfoProvider } from "./endpoints";
export var ClientSharedValues = {
    apiVersion: "2017-07-01",
    disableHostPrefix: false,
    regionInfoProvider: defaultRegionInfoProvider,
    signingName: "translate",
};
//# sourceMappingURL=runtimeConfig.shared.js.map